import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import alert from '../../../sass/images/alert/alert.svg';

const VALID_TYPES = ['image/png', 'image/jpg', 'image/jpeg', 'application/pdf'];
const MAX_SIZE = 6291456; // 6MB

function FormAdditionalApproval({ id, dataForm }) {
  const { t } = useTranslation('formInApproval');
  const [images1, setImages1] = useState([]);
  const [images2, setImages2] = useState([]);
  const [validateFile, setValidateFile] = useState(false);

  const notify = (i1, i2) => {
    if (dataForm) {
      dataForm({
        [`images1_${id}`]: i1,
        [`images2_${id}`]: i2,
      });
    }
  };

  const handleImages1Change = (e) => {
    setValidateFile(false);
    const files = Array.from(e.target.files).filter(
      ({ size, type }) => VALID_TYPES.includes(type) && size <= MAX_SIZE
    );
    e.target.value = '';
    if (files.length === 0) { setValidateFile(true); return; }
    const next = [...images1, ...files];
    setImages1(next);
    notify(next, images2);
  };

  const handleImages2Change = (e) => {
    setValidateFile(false);
    const files = Array.from(e.target.files).filter(
      ({ size, type }) => VALID_TYPES.includes(type) && size <= MAX_SIZE
    );
    e.target.value = '';
    if (files.length === 0) { setValidateFile(true); return; }
    const next = [...images2, ...files];
    setImages2(next);
    notify(images1, next);
  };

  const removeImage1 = (index) => {
    const next = images1.filter((_, i) => i !== index);
    setImages1(next);
    notify(next, images2);
  };

  const removeImage2 = (index) => {
    const next = images2.filter((_, i) => i !== index);
    setImages2(next);
    notify(images1, next);
  };

  return (
    <div className="block-form">
      <Row className="no-gutters content_in_process">
        <Col className="col-collapse" xs={12} sm={12} md={12}>
          <p>{t('quotation')}*</p>
          <input
            className="form-control inputfile inputfile-1"
            type="file"
            id={`images1_${id}`}
            multiple
            accept="image/*,.pdf"
            capture="environment"
            onChange={handleImages1Change}
          />
          <label htmlFor={`images1_${id}`}>
            <svg xmlns="http://www.w3.org/2000/svg" className="borrainputfile" width="20" height="17" viewBox="0 0 20 17">
              <path d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z" />
            </svg>
            <span className="borrainputfile">{t('select_files')}</span>
          </label>
          <div className="list_items_file">
            {images1.length > 0 && (
              <ul>
                {images1.map((file, index) => (
                  <li key={index}>
                    {file.name}{' '}
                    <button type="button" onClick={() => removeImage1(index)}>x</button>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </Col>

        <Col className="col-collapse" xs={12} sm={12} md={12}>
          <p>{t('quotation_img')}*</p>
          <input
            className="form-control inputfile inputfile-1"
            type="file"
            id={`images2_${id}`}
            multiple
            accept="image/*,.pdf"
            capture="environment"
            onChange={handleImages2Change}
          />
          <label htmlFor={`images2_${id}`}>
            <svg xmlns="http://www.w3.org/2000/svg" className="borrainputfile" width="20" height="17" viewBox="0 0 20 17">
              <path d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z" />
            </svg>
            <span className="borrainputfile">{t('select_files')}</span>
          </label>
          <div className="list_items_file">
            {images2.length > 0 && (
              <ul>
                {images2.map((file, index) => (
                  <li key={index}>
                    {file.name}{' '}
                    <button type="button" onClick={() => removeImage2(index)}>x</button>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </Col>

        {validateFile && (
          <div className="error_input">
            <p>
              <img src={alert} alt="notification" />
              {t('Algunos archivos no son válidos. Solo se permiten imágenes (PNG, JPG, JPEG) y PDFs de máximo 6MB.')}
            </p>
          </div>
        )}
      </Row>
    </div>
  );
}

FormAdditionalApproval.propTypes = {
  id: PropTypes.number.isRequired,
  dataForm: PropTypes.func.isRequired,
};

export default FormAdditionalApproval;
